import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { RouteEnum } from '../../routes/routes';
import { DateTime } from 'luxon';

export default function OnlineStatusButton() {
  const { company } = useSelector((state) => state.company);

  const isOffline = useMemo(
    () => company?.orders_paused_until && DateTime.fromISO(company?.orders_paused_until) > DateTime.local(),
    [company?.orders_pause_reason, company?.orders_paused_until],
  );

  return (
    <a
      className="w-[26px] h-[26px] bg-white rounded-full border border-gray-200 flex justify-center items-center shrink-0"
      href={RouteEnum.OrderControl}
    >
      <div
        className={classNames('w-[12px] h-[12px] rounded-full', {
          'bg-primary': !isOffline,
          'bg-danger': isOffline,
        })}
      />
    </a>
  );
}
